import { render, staticRenderFns } from "./PageUploadList.vue?vue&type=template&id=32e98dab&scoped=true&"
import script from "./PageUploadList.vue?vue&type=script&lang=js&"
export * from "./PageUploadList.vue?vue&type=script&lang=js&"
import style0 from "./PageUploadList.vue?vue&type=style&index=0&id=32e98dab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e98dab",
  null
  
)

export default component.exports